import { convertSnakeCaseToCamelCase } from "@swa-ui/string";

import { isObject } from "../isObject";

/**
 * convertKeysFromSnakeCaseToCamelCase generates an object whose keys are transformed from snake_case to camelCase.
 * @param objectWithSnakeCaseKeys the object with keys in snake_case
 * @returns the object with keys transformed from snake_case to camelCase
 */
export const convertKeysFromSnakeCaseToCamelCase = (object: unknown): unknown => {
  const transformObject = (
    obj: Record<string, unknown> | unknown[]
  ): Record<string, unknown> | unknown[] => {
    let output: Record<string, unknown> | unknown[];

    if (Array.isArray(obj)) {
      output = obj.map((item) => handleObjectAndArrays(item));
    } else {
      output = Object.keys(obj).reduce((acc, key) => {
        const camelKey = convertSnakeCaseToCamelCase(key);

        acc[camelKey] = handleObjectAndArrays(obj[key]);

        return acc;
      }, {} as Record<string, unknown>);
    }

    return output;
  };

  function handleObjectAndArrays(item: unknown): unknown {
    return isObject(item) || Array.isArray(item)
      ? transformObject(item as Record<string, unknown> | unknown[])
      : item;
  }

  return isObject(object) ? transformObject(object) : object;
};
